export enum BILLING_RUN_TYPE {
    CHARGING = 'charging',
    INVOICING = 'invoicing',
}

export enum BILLING_RUN_STATUS {
    RUNNING = 'running',
    COMPLETED = 'completed',
    FAILED = 'failed',
}

/** One record per scheduled or manual fan-out. Read-only apart from the trigger endpoint. */
export type BillingRun = {
    id: string;
    created_at: string;
    modified_at: string;
    type: BILLING_RUN_TYPE;
    status: BILLING_RUN_STATUS;
    business_date: string;
    started_at: string;
    finished_at: string | null;
    /** Undocumented in the brief but present on the API. Shown on the run dashboard. */
    error_detail: string | null;
    total_count: number;
    succeeded_count: number;
    failed_count: number;
    skipped_count: number;
    /** Null means the scheduled run rather than a person - render as "Scheduled", never as "-". */
    triggered_by: {
        id: string;
        name: string;
    } | null;
};
